import { Divider, Popconfirm } from 'antd';
import { Link } from 'react-router-dom';
import {
  ContainerOutlined,
  EyeOutlined,
  WarningOutlined
} from '@ant-design/icons';
import { deleteInvoice } from '../routes/invoices/utils/deleteInvoice';

/**
 * Creates an action column configuration for invoice data tables.
 * This utility function eliminates code duplication by generating the common structure
 * used across multiple invoice list components.
 *
 * @param {Object} params - Configuration parameters
 * @param {Function} params.t - Translation function from useTranslation hook
 * @param {Function} params.dispatchAPI - API dispatch function
 * @param {Function} params.message - Error message function
 * @param {Function} params.setRefreshData - Function to set refresh data state
 * @param {boolean} params.refreshData - Current refresh data state
 * @returns {Object} Column configuration object for invoice actions
 */
export const createInvoiceActionColumn = ({
  t,
  dispatchAPI,
  message,
  setRefreshData,
  refreshData
}) => ({
  key: 'action',
  align: 'right',
  fixed: 'right',
  width: 120,
  render: (record) => (
    <>
      <Link
        to={{
          pathname: `/invoices/customers/show/${record?._id}`
        }}
      >
        <EyeOutlined style={{ fontSize: 18 }} />
      </Link>
      {!['PAID', 'FREE'].includes(record?.status) && (
        <>
          <Divider type="vertical" />
          <Popconfirm
            title={t('datatable.column.action.archive.title')}
            okText={t('datatable.column.action.archive.ok')}
            okButtonProps={{ type: 'danger' }}
            cancelText={t('datatable.column.action.archive.cancel')}
            onConfirm={() =>
              deleteInvoice({
                dispatchAPI,
                id: record._id,
                message,
                setRefreshData,
                refreshData,
                path: 'customerinvoices'
              })
            }
            icon={<WarningOutlined />}
          >
            <ContainerOutlined
              style={{ color: '#b51010', fontSize: 18 }}
              type="delete"
            />
          </Popconfirm>
        </>
      )}
    </>
  )
});
